module.exports = __webpack_public_path__ + "media/bootstrap-icons/headset-vr-41c7c9e4.svg";